<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        name: 'App',
    }
</script>

<style>
    body {
        margin: 0;
        overflow: hidden;
    }
    #app {
        font-family: Avenir, Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
        /* height: 100vh; */
        background: #f2f4f6;
        /* margin-top: 60px; */
    }
</style>

<style lang="scss">
    .template_one {
        width: 100%;
        max-width: 1518px;
        position: relative;
        padding: 24px;
        margin: 24px;
        background: #fff;
        border-radius: 10px;
    }
    .flex_between {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .flex_around {
        display: flex;
        justify-content: space-around;
        align-items: center;
    }
    .flex_start {
        display: flex;
        justify-content: start;
        align-items: center;
    }
    .flex_center {
        display: flex;
        justify-content: center;
        align-items: center;
    }
    $margin-sizes: (
        '4': 4px,
        '5': 5px,
        '8': 8px,
        '10': 10px,
        '12': 12px,
        '14': 14px,
        '16': 16px,
        '20': 20px,
        '24': 24px,
        '40': 40px,
        '56': 56px,
    );
    $padding-sizes: (
        '4': 4px,
        '5': 5px,
        '8': 8px,
        '10': 10px,
        '12': 12px,
        '14': 14px,
        '16': 16px,
        '20': 20px,
        '24': 24px,
        '40': 40px,
        '56': 56px,
    );
    $font-sizes: (
        '12': 12px,
        '14': 14px,
        '16': 16px,
        '18': 18px,
        '20': 20px,
        '24': 24px,
        '40': 40px,
        '56': 56px,
    );

    @each $name, $size in $font-sizes {
        .fs-#{$name} {
            font-size: $size !important;
        }
    }
    // 生成动态边距类
    @each $name, $size in $padding-sizes {
        .p-#{$name} {
            padding: $size !important;
        }
        .pt-#{$name} {
            padding-top: $size !important;
        }
        .pr-#{$name} {
            padding-right: $size !important;
        }
        .pb-#{$name} {
            padding-bottom: $size !important;
        }
        .pl-#{$name} {
            padding-left: $size !important;
        }
        .px-#{$name} {
            padding-right: $size !important;
            padding-left: $size !important;
        }
        .py-#{$name} {
            padding-top: $size !important;
            padding-bottom: $size !important;
        }
    }
    @each $name, $size in $margin-sizes {
        .m-#{$name} {
            margin: $size !important;
        }
        .mt-#{$name} {
            margin-top: $size !important;
        }
        .mr-#{$name} {
            margin-right: $size !important;
        }
        .mb-#{$name} {
            margin-bottom: $size !important;
        }
        .ml-#{$name} {
            margin-left: $size !important;
        }
        .mx-#{$name} {
            margin-right: $size !important;
            margin-left: $size !important;
        }
        .my-#{$name} {
            margin-top: $size !important;
            margin-bottom: $size !important;
        }
    }
</style>
